import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Checkbox from "@mui/material/Checkbox";
import Divider from "@mui/material/Divider";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Stack from "@mui/material/Stack";
import ThemeContext from "components/app/Context";
import Button from "components/common/Button";
import Typography from "components/common/Typography";
import * as React from "react";
import { useContext, useState } from "react";
import { tokens } from "styles/Tokens";

interface Props {
  label: string;
  options: any;
  optionKeyName?: string;
  onSubmit: (args?: any) => void;
  isFiltered?: boolean;
  upperCase?: boolean;
  selectedOptions: any;
}

const MultiSelectFilter = (props: Props) => {
  const { label, options, optionKeyName, onSubmit, isFiltered, upperCase = false, selectedOptions } = props;
  const { isMobileScreen } = useContext(ThemeContext);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [selected, setSelected] = useState<Array<string>>([]);

  React.useEffect(() => {
    window.dispatchEvent(new CustomEvent("resize"));
  }, [open === true]);

  React.useEffect(() => {
    if (!isFiltered) {
      setSelected([]);
    }
  }, [isFiltered]);

  React.useEffect(() => {
    setSelected(selectedOptions);
  }, [selectedOptions]);

  const handleOpenMenu = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (e: any, reason: any) => {
    setAnchorEl(null);
  };

  const handleSubmit = () => {
    onSubmit(selected);
    setAnchorEl(null);
  };

  const handleMenuChange = (val: string) => {
    if (selected.includes(val)) {
      setSelected(selected.filter((s: any) => s !== val));
    } else {
      setSelected([...selected, val]);
    }
  };

  return (
    <>
      <Stack
        direction="row"
        alignItems="center"
        sx={{
          backgroundColor: tokens.Background.General.Tertiary,
          height: "44px",
          paddingX: "8px",
          borderRadius: "8px",
          cursor: "pointer",
          flex: isMobileScreen ? 1 : 0,
          marginBottom: "8px !important"
        }}
        onClick={handleOpenMenu}
      >
        <Typography
          variant="body2"
          showBold
          color={tokens.Text.General.Secondary}
          sx={{ flex: 1, whiteSpace: "nowrap" }}
        >
          {`${label} ${selected?.length ? `(${selected?.length})` : ""}`}
        </Typography>
        {open ? <KeyboardArrowUpIcon sx={{ fontSize: "20px" }} /> : <KeyboardArrowDownIcon sx={{ fontSize: "20px" }} />}
      </Stack>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        PaperProps={{
          style: {
            maxHeight: "300px"
          }
        }}
      >
        {options?.map(
          (opt: any) =>
            opt &&
            opt !== undefined && (
              <MenuItem
                key={optionKeyName ? opt[optionKeyName] : opt}
                onClick={() => handleMenuChange(optionKeyName ? opt[optionKeyName] : opt)}
                sx={{ textTransform: upperCase ? "uppercase" : "none" }}
              >
                <Checkbox checked={selected?.includes(optionKeyName ? opt[optionKeyName] : opt)} />
                {optionKeyName ? opt[optionKeyName] : opt}
              </MenuItem>
            )
        )}
        <Divider />
        <Stack direction="row" alignItems="center" sx={{ padding: "0 16px" }} spacing={1}>
          <Button variant="secondary" label="Clear Selection" onClick={() => setSelected([])} />
          <Button label="OK" onClick={handleSubmit} />
        </Stack>
      </Menu>
    </>
  );
};

export default MultiSelectFilter;
